var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"poster-block"},[_c('container-grid-size',[_vm._v(" "+_vm._s(_vm.blc.blockType)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }